export const formatDecimal = (value: number | null | undefined, suffix = ""): string =>
  value !== null && value !== undefined
    ? `${Number(value).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${suffix}`
    : "-";

export const formatPercent = (value: number | null | undefined): string =>
  value !== null && value !== undefined
    ? formatDecimal(Number(value) * 100, "%")
    : "-";

export const formatDate = (value: string | null | undefined): string => {
  const date = new Date(value || "");
  return isNaN(date.getTime())
    ? "-"
    : `${date.getDate().toString().padStart(2, "0")}.${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}.${date.getFullYear()}`;
};

export function formatCurrency(value: number | string | undefined | null): string {
  const numeric = typeof value === "string" ? parseFloat(value) : value;
  return numeric !== undefined && numeric !== null && !isNaN(numeric)
    ? `${numeric.toLocaleString("de-DE")} EUR`
    : "";
}

export function formatNumber(value: number, decimals: number = 0): string {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
}
